export default {
  path: 'openAccount',
  component: () => import(/* webpackChunkName: "roles-list" */ '@/pages/taxReturn/openAccount'),
  meta: {title:'申报中心',cate:'开户'},
  // children: [
  // ]
}